import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
  TablePagination
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import styles from './styles.module.css';
import close from '../../../images/PlayerHistoryPopup/close.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlayerHistory } from '../../../store/slices/playerHistorySlice';
import dropdownIcon from "../../../images/PlayerHistoryPopup/dropdownIcon.svg"



const PlayerHistoryPopup = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { records, total, loading } = useSelector(
    (state) => state.playerHistory
  );
  const { userId } = useSelector((state) => state.auth);

  const [dateFilter, setDateFilter] = useState('Today');
const [gameFilter, setGameFilter] = useState('Roulette');

  useEffect(() => {
    if (open && userId) {
      dispatch(fetchPlayerHistory({ userId, dateFilter, gameFilter }));
    }
  }, [open, dispatch, userId, dateFilter, gameFilter]);

  const rows = [
    { id: '12345678910111213', game: 'Tiger' },
    { id: '12345678910111213', game: 'Dragon' },
    { id: '12345678910111213', game: 'Tiger' },
    { id: '12345678910111213', game: 'Dragon' },
    { id: '12345678910111213', game: 'Tiger' },
    { id: '12345678910111213', game: 'Dragon' },
    { id: '12345678910111213', game: 'Tiger' },
    { id: '12345678910111213', game: 'Dragon' },
  ];

  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [gameAnchorEl, setGameAnchorEl] = useState(null);

  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(1390 / 10);


  const openDateMenu = Boolean(dateAnchorEl);
  const openGameMenu = Boolean(gameAnchorEl);

  const handleDateClick = (event) => {
    setDateAnchorEl(event.currentTarget);
  };

  const handleGameClick = (event) => {
    setGameAnchorEl(event.currentTarget);
  };

  const handleDateSelect = (value) => {
    setDateFilter(value);
    setDateAnchorEl(null);
    if (userId) {
      dispatch(fetchPlayerHistory({ userId, dateFilter: value, gameFilter }));
    }
  };

  const handleGameSelect = (value) => {
    setGameFilter(value);
    setGameAnchorEl(null);
    if (userId) {
      dispatch(fetchPlayerHistory({ userId, dateFilter, gameFilter: value }));
    }
  };


  return (
    <Dialog
      // className={styles.PopupContent}
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 0, // Remove rounded corners
        },
      }}>

      <Box className={styles.PopupHeadBox}>
        <Typography className={styles.PopupTitleText}>Player History</Typography>
        <IconButton className={styles.PopupCloseButton} onClick={onClose}>
          <img src={close} alt="Close" />
        </IconButton>
      </Box>

      <Box className={styles.PopupContent}>
        {/* Date Filter Box */}
        <Box className={styles.FilterBox_container}>
          <Box
            className={styles.FilterBox}
            onClick={handleDateClick}>
            <Typography className={styles.filtertext}>{dateFilter}</Typography>
            <img src={dropdownIcon} alt="DownIcon" />

          </Box>

          {/* Game Filter Box */}
          <Box
            onClick={handleGameClick}
            className={styles.FilterBox}
          >
            <Typography className={styles.filtertext}>{gameFilter}</Typography>
            <img src={dropdownIcon} alt="DownIcon" />
          </Box>
        </Box>

        {/* Submit Button */}

        <Button className={styles.SubmitButton}>
          <Typography className={styles.SubmitText}>Submitttttttttttttttttttt</Typography>
        </Button>


        {/* Table Data */}
        <Box sx={{ width: '100%' }}>

          <Box className={styles.PlayerHistoryTableHeadRow}>
            <Box className={styles.RoundidBox}>
              <Box className={styles.PlayerHistoryTableHeadCell2}>Round ID</Box>
            </Box>
            <Box className={styles.PlayerHistoryTableHeadCell}>Game Name</Box>
          </Box>

          <Box sx={{ width: '100%' }}>
            {records.map((row, idx) => (
              <Box key={idx} className={styles.PlayerHistoryTableRow}>
                {/* <Box className={styles.PlayerHistoryGameNameCell_container}> */}
                {/* <Box className={styles.PlayerHistoryGameNameCell}> */}
                <Box className={styles.TableCell_box}>
                  <Typography className={styles.TableCell_txt}>{row.roundId}</Typography>
                  {/* </Box> */}
                </Box>
                {/* <Box className={styles.PlayerHistoryGameNameCell}> */}
                <Box className={styles.TableCell_box2}>
                  <Typography className={styles.TableCell_txt2}>{row.gameName}</Typography>
                </Box>
                {/* </Box> */}
                {/* </Box> */}
              </Box>
            ))}
          </Box>
        </Box>


        {/* Buttons */}
        <Box className={styles.FilterBoxesBody}>
          {['First', 'Previous', 'Next', 'Last'].map((label) => (
            <Box key={label} className={styles.FilterBox_boxes}>
              <Typography className={styles.FilterBox_text}>{label}</Typography>
            </Box>
          ))}
        </Box>

        {/* Page Info and Goto Page */}
        <Box className={styles.PageInfoBox}>
          <Typography className={styles.PageInfoText}>
            Page
          </Typography>
          <Typography className={styles.PageInfoText2}>1 of 139 </Typography>
          <Typography className={styles.PageInfoText3}>|</Typography>
          <Typography className={styles.PageInfoTextGoTo}>Goto page</Typography>
          <Box
            component="input"
            type="number"
            defaultValue={1}
            min={1}
            max={139}
            className={`${styles.PageInfoInputBox} ${styles.PageInfoInputText}`}
          />
        </Box>


      </Box>

      {/* Date Menu */}
      <Menu
        anchorEl={dateAnchorEl}
        open={openDateMenu}
        // className={styles.FilterBox}
        onClose={() => setDateAnchorEl(null)}
      >
        {['Today', 'Yesterday', '2 Days Ago'].map((option, idx) => (
          <MenuItem key={idx} onClick={() => handleDateSelect(option)}>
            {option}
          </MenuItem>
        ))}
      </Menu>

      {/* Game Menu */}
      <Menu
        anchorEl={gameAnchorEl}
        open={openGameMenu}
        onClose={() => setGameAnchorEl(null)}
      >
       jsx{['All', 'Roulette', 'Dragon Tiger', 'Tiger'].map((option, idx) => (
    <MenuItem key={idx} onClick={() => handleGameSelect(option)}>
        {option}
    </MenuItem>
))}
      </Menu>
    </Dialog>
  );
};

export default PlayerHistoryPopup;
